import { Link } from "react-router-dom";
import { Instagram, Music2 } from "lucide-react";
import { scrollToId, waLink, WA_MESSAGES, WA_NUMBER_DISPLAY } from "@/lib/site";

const NAV = [
    { label: "Destinations", id: "destinations" },
    { label: "VIP Tables", id: "vip-tables" },
    { label: "How It Works", id: "how-it-works" },
    { label: "FAQ", id: "faq" },
    { label: "Contact", id: "book" },
];

const Footer = () => (
    <footer
        data-testid="footer"
        className="border-t border-white/10 bg-[#050505]"
    >
        <div className="mx-auto max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="grid gap-12 md:grid-cols-4">
                <div className="md:col-span-2">
                    <p className="text-sm font-extrabold uppercase tracking-[0.4em] text-ivory">
                        BookMyVIP
                    </p>
                    <p className="mt-4 font-serif text-xl italic text-gold">
                        "The world's best nights, reserved."
                    </p>
                    <div className="mt-8 flex items-center gap-6">
                        <a
                            data-testid="footer-instagram-link"
                            href="https://www.instagram.com/bookmyvip"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="BookMyVIP on Instagram"
                            className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-ivory/70 transition-colors duration-300 hover:text-gold"
                        >
                            <Instagram size={14} strokeWidth={1.5} /> Instagram
                        </a>
                        <span
                            data-testid="footer-tiktok-placeholder"
                            className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-muted/60"
                        >
                            <Music2 size={14} strokeWidth={1.5} /> TikTok — soon
                        </span>
                    </div>
                </div>

                <div>
                    <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-muted">
                        Navigate
                    </p>
                    <ul className="mt-5 space-y-3">
                        {NAV.map((n) => (
                            <li key={n.id}>
                                <button
                                    data-testid={`footer-link-${n.id}`}
                                    onClick={() => scrollToId(n.id)}
                                    className="text-sm text-ivory/70 transition-colors duration-300 hover:text-gold"
                                >
                                    {n.label}
                                </button>
                            </li>
                        ))}
                        <li>
                            <Link
                                data-testid="footer-link-journal"
                                to="/blog"
                                className="text-sm text-ivory/70 transition-colors duration-300 hover:text-gold"
                            >
                                Journal
                            </Link>
                        </li>
                    </ul>
                </div>

                <div>
                    <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-muted">
                        Contact
                    </p>
                    <a
                        data-testid="footer-whatsapp-link"
                        href={waLink(WA_MESSAGES.concierge)}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Opens WhatsApp"
                        className="mt-5 block text-sm text-ivory/70 transition-colors duration-300 hover:text-gold"
                    >
                        WhatsApp: {WA_NUMBER_DISPLAY}
                    </a>
                    <p className="mt-8 text-[10px] font-bold uppercase tracking-[0.3em] text-muted">
                        Legal
                    </p>
                    <ul className="mt-5 space-y-3">
                        {[
                            { label: "Privacy Policy", path: "/privacy-policy" },
                            { label: "Terms & Conditions", path: "/terms-and-conditions" },
                            { label: "Booking Policy", path: "/booking-policy" },
                        ].map((l) => (
                            <li key={l.path}>
                                <Link
                                    data-testid={`footer-legal-${l.path.slice(1)}`}
                                    to={l.path}
                                    className="text-sm text-muted/70 transition-colors duration-300 hover:text-gold"
                                >
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
                <p className="text-[11px] uppercase tracking-[0.25em] text-muted/50">
                    © 2026 BookMyVIP. All rights reserved.
                </p>
                <p className="text-[11px] uppercase tracking-[0.25em] text-muted/50">
                    Bangkok <span className="text-gold">•</span> Phuket{" "}
                    <span className="text-gold">•</span> Pattaya{" "}
                    <span className="text-gold">•</span> Koh Samui
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
